const arraySymmetricDifference = <T>(arr1: T[], arr2: T[]) => arr1
  .filter(elem1 => !arr2.includes(elem1))
  .concat(arr2.filter(elem2 => !arr1.includes(elem2)));

export default arraySymmetricDifference;
